import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "emptyTooth",
  "use": "emptyTooth-usage",
  "viewBox": "0 0 18 18",
  "content": "<symbol viewBox=\"0 0 18 18\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"emptyTooth\">\r\n    <circle cx=\"9.14466\" cy=\"9.26576\" r=\"7.68703\" stroke=\"#FA8989\" stroke-width=\"1.70823\" />\r\n    <path d=\"M11.4495 11.8281L6.5843 6.70344M6.84374 11.8281L11.709 6.70344\" stroke=\"#FA8989\" stroke-width=\"1.70823\" stroke-linecap=\"round\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol